import useAuth from "../hooks/useAuth";
import PropTypes from "prop-types";

const ProtectedComponent = ({
  component: Component,
  fallback: Fallback,
  ...rest
}) => {
  const { authenticated } = useAuth();

  return authenticated ? <Component {...rest} /> : <Fallback {...rest} />;
};

ProtectedComponent.propTypes = {
  component: PropTypes.elementType.isRequired,
  fallback: PropTypes.elementType.isRequired,
};

export default ProtectedComponent;
